const dict = {
  languageName: 'Español',
  locale: 'es',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: 'Tema',
  'theme.light': 'Claro',
  'theme.dark': 'Oscuro',
  'theme.system': 'Sistema',
  'theme.sakura': 'Sakura',

  // generic
  email: 'Email',
  password: 'Contraseña',
  ok: 'Aceptar',
  cancel: 'Cancelar',
  retry: 'Reintentar',
  copy: 'Copiar',
  empty: '(sin elementos)',
  loading: 'Cargando...',
  calculating: 'Calculando...',
  error: 'Error',

  'in_development': 'Esta página está en desarrollo.',

  // errors
  'error.not_found': 'no encontrado',
  'error.name_conflict': 'conflicto de nombres',
  'error.bad_param': 'parámetro incorrecto',
  'error.wrong_auth': 'autenticación incorrecta',
  'error.unauthorized': 'no autorizado',
  'error.wrong_credentials': 'credenciales incorrectas',
  'error.wrong_provider': 'proveedor incorrecto',
  'error.insufficient_privileges': 'privilegios insuficientes',
  'error.not_empty': 'no vacío',
  'error.limit_exceeded': 'límite excedido',
  'error.already_member': 'ya es miembro',
  'error.not_finalized': 'no finalizado',
  'error.already_finalized': 'ya finalizado',
  'error.unexpected_patch': 'parche inesperado',
  'error.timeout': 'tiempo de espera agotado',
  'error.not_patch': 'no es un parche',
  'error.not_supported': 'no soportado',
  'error.unexpected_error': 'error inesperado',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': 'Autenticación',
  'auth.dialog.please_select': 'Selecciona tu proveedor de cuenta para iniciar sesión.',
  'auth.dialog.redirecting_to': (provider) => `Redirigiendo a ${provider}...`,
  'auth.dialog.remember_me': 'Recordarme',
  'auth.dialog.log_in': 'Iniciar sesión',
  'auth.dialog.back': 'Atrás',
  'auth.dialog.progress_header': 'Autenticando...',
  'auth.dialog.error.header': 'Error de autenticación',
  'auth.dialog.error.auth_not_allowed': 'El usuario ha prohibido el uso de esta credencial para la autenticación. Usa otra credencial.',
  'auth.dialog.error.unknown': 'Parámetros de autenticación no válidos. Inténtalo de nuevo.',
  'auth.dialog.error.back': 'Volver',

  'user.profile': 'Perfil',
  'user.logout': 'Cerrar sesión',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': 'Página no encontrada',
  'page_not_found.message': 'Esta página no existe.',
  'page_not_found.message2': 'Bueno, en cierto modo sí, pero no hay nada aquí. Estas son las posibilidades.',
  'page_not_found.items': [
    'Había algo aquí antes, pero ya se ha eliminado.',
    'Todavía hay algo aquí, pero no tienes acceso.',
    'O simplemente alguien no tuvo cuidado al copiar y pegar el enlace.',
  ],

  'home': 'Inicio',
  'home.header.hint': 'Herramientas en la nube para desarrolladores indie',
  'home.description': 'Kavykhi.Cloud es una plataforma de desarrollo para juegos indie. Soportamos juegos descargables y de navegador, versiones públicas y privadas, ramas, equipos y mucho más.',
  'home.auth': 'Iniciar sesión o registrarse',
  'home.auth.hint': 'Crea una cuenta nueva o inicia sesión en una existente',

  'projects': 'Proyectos',
  'projects.hint': 'Los proyectos en los que estás trabajando',
  'projects.project': (project) => `Proyecto: ${project}`,
  'projects.project.hint': 'proyecto',
  'projects.no_projects': 'Aún no tienes proyectos.',
  'projects.new': 'Crear proyecto',
  'projects.new_dialog.header': 'Nuevo proyecto',
  'projects.new_dialog.label': 'Nombre del proyecto',
  'projects.new_dialog.ok': 'Crear proyecto',
  'projects.store_page': 'Página pública de la tienda',
  'projects.description': 'Descripción',
  'projects.branches': 'Ramas',
  'projects.versions': 'Versiones',
  'projects.packages': 'Paquetes',
  'projects.management': 'Ajustes del proyecto',
  'projects.management.breadcrumb': 'Ajustes',
  'projects.management.title': (projectTitle) => `${projectTitle} - ajustes`,
  'projects.management.hint': 'ajustes del proyecto',
  'projects.management.users': 'Miembros del equipo',
  'projects.management.users.empty': 'Sin miembros en el equipo.',
  'projects.management.users.role.tester': 'Tester',
  'projects.management.users.role.developer': 'Desarrollador',
  'projects.management.users.role.admin': 'Administrador',
  'projects.management.users.role.owner': 'Propietario',
  'projects.management.users.role.starred': 'Destacado',
  'projects.management.users.exile': 'Eliminar del equipo',
  'projects.management.users.exile.dialog.header': 'Eliminar del equipo',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>¿Seguro que quieres eliminar a {userTitle} del proyecto {projectTitle}?</>,
  'projects.management.users.exile.dialog.ok': 'Eliminar del equipo',
  'projects.management.invites.one_time_invite': 'Enlace de invitación de un solo uso',
  'projects.management.invites.one_time_invite.header': 'Enlace de invitación de un solo uso',
  'projects.management.invites.one_time_invite.message': 'Enlace de invitación de un solo uso:',
  'projects.management.invites.one_time_invite.note': 'Válido por 24 horas, se puede usar una vez.',
  'projects.management.invites.new_dialog.header': 'Enlace de invitación',
  'projects.management.invites.new_dialog.expires': 'Expira en:',
  'projects.management.invites.new_dialog.expires.indefinite': '(sin expiración)',
  'projects.management.invites.new_dialog.approval.label': 'El usuario se une al proyecto:',
  'projects.management.invites.new_dialog.approval.not_approved': 'tras aprobación del admin',
  'projects.management.invites.new_dialog.approval.approved': 'inmediatamente',
  'projects.management.invites.new_dialog.seats': 'Límite de uniones:',
  'projects.management.invites.new_dialog.seats.no_limit': '(sin límite)',
  'projects.management.invites.new_dialog.ok': 'Crear enlace de invitación',
  'projects.management.deploy_sites': 'Sitios de despliegue',
  'projects.management.deploy_sites.empty': 'No se han añadido sitios de despliegue.',
  'projects.management.deploy_sites.add': 'Añadir sitio de despliegue',
  'projects.management.deploy_sites.delete': 'Eliminar',
  'projects.management.deploy_sites.delete_dialog.header': 'Eliminar sitio de despliegue',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>¿Seguro que quieres eliminar el sitio de despliegue {provider} {site}?</>,
  'projects.management.deploy_sites.delete_dialog.ok': 'Eliminar sitio de despliegue',
  'projects.management.public_access': 'Acceso público',
  'projects.management.public_access.enable': 'Habilitar acceso público',
  'projects.management.public_access.enabled': <>Acceso público: <strong>permitido</strong></>,
  'projects.management.public_access.enabled.note': 'El nombre y la descripción del proyecto son públicos, así como cualquier rama marcada como pública.',
  'projects.management.public_access.enable_dialog.header': 'Habilitar acceso público',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>¿Seguro que quieres permitir el acceso público al proyecto {projectTitle}?<br /><br />Esto hará que la información básica del proyecto esté disponible sin autenticación. Deberás habilitar el acceso público por separado para cada rama que quieras que sea pública.</>,
  'projects.management.public_access.enable_dialog.ok': 'Habilitar acceso público',
  'projects.management.public_access.disable': 'Deshabilitar acceso público',
  'projects.management.public_access.disabled': <>Acceso público: <strong>no permitido</strong></>,
  'projects.management.public_access.disabled.note': 'El proyecto es privado. Solo los miembros del equipo del proyecto pueden acceder.',
  'projects.management.public_access.disable_dialog.header': 'Deshabilitar acceso público',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>¿Seguro que quieres deshabilitar todo el acceso público al proyecto {projectTitle}?</>,
  'projects.management.public_access.disable_dialog.ok': 'Deshabilitar acceso público',
  'projects.management.public_access.branches': 'Ramas públicas',
  'projects.management.manage': 'Gestionar proyecto',
  'projects.rename': 'Renombrar proyecto',
  'projects.rename_dialog.header': 'Renombrar proyecto',
  'projects.rename_dialog.label': 'Nombre del proyecto:',
  'projects.rename_dialog.ok': 'Renombrar proyecto',
  'projects.edit_description': 'Editar descripción del proyecto',
  'projects.edit_description_dialog.header': 'Editar descripción del proyecto',
  'projects.edit_description_dialog.label': 'Descripción del proyecto:',
  'projects.edit_description_dialog.ok': 'Editar descripción',
  'projects.leave': 'Salir del proyecto',
  'projects.leave_dialog.header': 'Salir del proyecto',
  'projects.leave_dialog.message': (projectTitle) => <>¿Seguro que quieres salir del proyecto {projectTitle}?</>,
  'projects.leave_dialog.ok': 'Salir del proyecto',
  'projects.delete': 'Eliminar proyecto',
  'projects.delete_dialog.header': 'Eliminar proyecto',
  'projects.delete_dialog.message': (projectTitle) => <>¿Seguro que quieres eliminar el proyecto {projectTitle}?</>,
  'projects.delete_dialog.ok': 'Eliminar proyecto',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': 'rama',
  'branches.no_branches': 'El proyecto aún no tiene ramas',
  'branches.new': 'Crear rama',
  'branches.new_dialog.header': 'Nueva rama',
  'branches.new_dialog.label': 'Nombre de la rama',
  'branches.new_dialog.ok': 'Crear rama',
  'branches.current_version': (version) => <>Versión actual: {version}</>,
  'branches.current_version.packages': 'Paquetes de la versión actual',
  'branches.no_current_version': 'Sin versión actual',
  'branches.publish_version.new': 'Publicar nueva versión',
  'branches.publish_version.existing': 'Republicar versión existente',
  'branches.version_history': 'Historial de versiones',
  'branches.version_history.empty': 'El historial de versiones de la rama está vacío.',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>La versión actual de la rama se conserva {quotaTime != null ? <>durante {quotaTime}</> : <>indefinidamente</>}. Las versiones anteriores se conservan por un máximo de {quotaNonCurrentTime}. No se conservan más de {plural(quotaCount, <>{quotaCountText} versión</>, <>{quotaCountText} versiones</>)} en total por rama.</>,
  'branches.manage': 'Gestionar rama',
  'branches.rename': 'Renombrar rama',
  'branches.rename_dialog.header': 'Renombrar rama',
  'branches.rename_dialog.label': 'Nombre de la rama:',
  'branches.rename_dialog.ok': 'Renombrar rama',
  'branches.delete': 'Eliminar rama',
  'branches.delete_dialog.header': 'Eliminar rama',
  'branches.delete_dialog.message': (branchTitle) => <>¿Seguro que quieres eliminar la rama {branchTitle}?</>,
  'branches.delete_dialog.ok': 'Eliminar rama',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': 'versión',
  'versions.current': 'Actual',
  'versions.previous': 'Anterior',
  'versions.description': 'Descripción',
  'versions.deploy_to_site.header': 'Publicar en sitio',
  'versions.deploy_to_site': 'Publicar en sitio',
  'versions.packages': 'Paquetes',
  'versions.branches': 'En ramas',
  'versions.branches.publish': 'Publicar en rama',
  'versions.branches.empty': 'La versión no se ha publicado en ninguna rama.',
  'versions.new_dialog.header': 'Nueva versión',
  'versions.new_dialog.label_title': 'Versión:',
  'versions.new_dialog.label_branch': 'Rama:',
  'versions.new_dialog.packages.header': 'Paquetes',
  'versions.new_dialog.packages.empty': 'No se han añadido paquetes.',
  'versions.new_dialog.packages.add': 'Añadir paquete',
  'versions.new_dialog.packages.add_existing': 'Añadir paquete subido previamente',
  'versions.new_dialog.packages.replace': 'Reemplazar paquete',
  'versions.new_dialog.packages.edit': 'Editar paquete',
  'versions.new_dialog.ok': 'Crear versión',
  'versions.manage': 'Gestionar versión',
  'versions.rename': 'Renombrar versión',
  'versions.rename_dialog.header': 'Renombrar versión',
  'versions.rename_dialog.label': 'Nombre de la versión:',
  'versions.rename_dialog.ok': 'Renombrar versión',
  'versions.edit_description': 'Editar descripción de la versión',
  'versions.edit_description_dialog.header': 'Editar descripción de la versión',
  'versions.edit_description_dialog.label': 'Descripción de la versión:',
  'versions.edit_description_dialog.ok': 'Editar descripción',
  'versions.delete': 'Eliminar versión',
  'versions.delete_dialog.header': 'Eliminar versión',
  'versions.delete_dialog.message': (versionTitle) => <>¿Seguro que quieres eliminar la versión {versionTitle}?</>,
  'versions.delete_dialog.ok': 'Eliminar versión',

  'versions.publish_dialog.header': 'Publicar versión en una rama',
  'versions.publish_dialog.message': (versionTitle) => <>Elige la rama en la que publicar la versión {versionTitle}.</>,
  'versions.publish_dialog.no_branches': 'No hay ramas en el proyecto.',
  'versions.publish_dialog.ok': 'Publicar versión',

  'versions.publish_existing_dialog.header': 'Republicar versión',
  'versions.publish_existing_dialog.message': 'Últimas versiones:',
  'versions.publish_existing_dialog.no_versions': 'No hay versiones en el proyecto.',
  'versions.publish_existing_dialog.ok': 'Publicar versión',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': 'Paquete',
  'packages.download_zip': 'Descargar como ZIP',
  'packages.download_torrent': 'Descargar torrent',
  'packages.total_size': (size) => <>Tamaño total: {size}</>,
  'packages.manage': 'Gestionar paquete',
  'packages.rename': 'Renombrar paquete',
  'packages.rename_dialog.header': 'Renombrar paquete',
  'packages.rename_dialog.label': 'Nombre del paquete:',
  'packages.rename_dialog.ok': 'Renombrar paquete',
  'packages.edit_tags': 'Editar etiquetas del paquete',
  'packages.edit_tags_dialog.header': 'Editar etiquetas del paquete',
  'packages.edit_tags_dialog.message': (packageTitle) => <>Especifica las etiquetas del paquete {packageTitle}:</>,
  'packages.edit_tags_dialog.ok': 'Establecer etiquetas',
  'packages.entrypoint': (entrypoint) => <>Archivo de inicio: {entrypoint}</>,
  'packages.entrypoint.empty': 'No se ha establecido el archivo de inicio.',
  'packages.delete': 'Eliminar paquete',
  'packages.delete_dialog.header': 'Eliminar paquete',
  'packages.delete_dialog.message': (packageTitle) => <>¿Seguro que quieres eliminar el paquete {packageTitle}? Se eliminará de todas las versiones a las que fue añadido.</>,
  'packages.delete_dialog.ok': 'Eliminar paquete',

  'packages.new_dialog.header': 'Nuevo paquete',
  'packages.new_dialog.label_title': 'Título:',
  'packages.new_dialog.title_placeholder': '(desde etiquetas)',
  'packages.new_dialog.tags.header': 'Etiquetas',
  'packages.new_dialog.files.header': 'Archivos',
  'packages.new_dialog.total_size': (size, maximum) => <>Tamaño total: {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(máximo {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>Tamaño de datos nuevos: {size}</>,
  'packages.new_dialog.checks.empty': 'No se han añadido archivos.',
  'packages.new_dialog.checks.entrypoint.empty': 'No se ha establecido el archivo de inicio.',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>El archivo de inicio {entrypoint} no existe; ¿quizás olvidaste añadirlo? Especifica un archivo de inicio existente, o no establezcas ninguno.</>,
  'packages.new_dialog.checks.entrypoint.missing.action': 'Quitar archivo de inicio',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>El archivo de inicio tiene la extensión {fileExt}: se sugiere la etiqueta {tag}.</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>Añadir etiqueta {tag}</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>El archivo de inicio tiene la extensión {fileExt}: añade la etiqueta {tag} para que el paquete se pueda jugar en el navegador.</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>El archivo de inicio tiene la extensión {fileExt}: ¿es un error? Normalmente no es un tipo de archivo ejecutable.</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>El archivo de inicio tiene la extensión {fileExt}: se recomienda incluir los archivos de contenido reales en lugar de empaquetarlos en un archivo comprimido.</>,
  'packages.new_dialog.checks.entrypoint.executable': 'El archivo de inicio no está marcado como ejecutable',
  'packages.new_dialog.checks.entrypoint.executable.action': 'Marcar como ejecutable',
  'packages.new_dialog.checks.single_root_dir': 'Se recomienda colocar los archivos directamente en la raíz, en lugar de tener una única carpeta en la raíz.',
  'packages.new_dialog.checks.single_root_dir.action': 'Reemplazar carpeta con su contenido',

  'packages.add_existing_dialog.header': 'Añadir paquete',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `Añadir ${plural(packagesCount, `${packagesCount} paquete`, `${packagesCount} paquetes`)}` : 'Ningún paquete seleccionado',
  'packages.add_existing_dialog.message': 'Últimos paquetes subidos:',
  'packages.add_existing_dialog.no_packages': 'No hay paquetes subidos recientemente.',

  'packages.launch': 'Iniciar',

  'packages.install': 'Instalar',
  'packages.install_dialog.header': 'Instalar',
  'packages.install_dialog.workdir.label': 'Directorio de trabajo:',
  'packages.install_dialog.workdir.value.new': '(crear nuevo)',
  'packages.install_dialog.workspace.label': 'Crear carpeta bajo:',
  'packages.install_dialog.workspace.placeholder': '(seleccionar carpeta raíz)',
  'packages.install_dialog.ok': 'Instalar',

  'packages.update': 'Actualizar',

  'packages.upload.status.existing': 'De la versión anterior',
  'packages.upload.status.queued': 'En cola',
  'packages.upload.status.packing': 'Empaquetando...',
  'packages.upload.status.creating': 'Creando...',
  'packages.upload.status.create_retrying': 'Error al crear, esperando y reintentando',
  'packages.upload.status.splitting': 'Dividiendo...',
  'packages.upload.status.uploading': 'Subiendo...',
  'packages.upload.status.finalizing': 'Finalizando...',
  'packages.upload.status.finalize_retrying': 'Error al finalizar, esperando y reintentando',
  'packages.upload.status.resolving': 'Resolviendo parche...',
  'packages.upload.status.resolve_retrying': 'Error al resolver parche, esperando y reintentando...',
  'packages.upload.status.done': 'Subido con éxito',
  'packages.upload.status.errored': 'Error',

  'packages.upload.part.status.queued': 'En cola',
  'packages.upload.part.status.hashing': 'Calculando hash',
  'packages.upload.part.status.upload_queued': 'Subida en cola',
  'packages.upload.part.status.uploading': 'Subiendo',
  'packages.upload.part.status.upload_retrying': 'Error, reintentando subida',
  'packages.upload.part.status.upload_finalizing': 'Finalizando subida',
  'packages.upload.part.status.upload_errored': 'Error',
  'packages.upload.part.status.done': 'Subido',

  'packages.play': 'Jugar en navegador',
  'packages.play.reset': 'Reiniciar',
  'packages.play.fullscreen': 'Pantalla completa',

  'deploy_sites.add_dialog.header': 'Añadir sitio de despliegue',
  'deploy_sites.add_dialog.message': (projectTitle) => <>Elige una credencial de despliegue e introduce la URL del sitio para guardarlos como sitio de despliegue para el proyecto {projectTitle}.</>,
  'deploy_sites.add_dialog.label_credential': 'Credencial de despliegue:',
  'deploy_sites.add_dialog.select_credential': 'Seleccionar credencial',
  'deploy_sites.add_dialog.select_credential.new': 'Añadir nueva credencial...',
  'deploy_sites.add_dialog.label_select_site': 'Seleccionar sitio:',
  'deploy_sites.add_dialog.select_credential_first': '(selecciona primero una credencial)',
  'deploy_sites.add_dialog.select_site': '(seleccionar sitio)',
  'deploy_sites.add_dialog.label_enter_site': 'O introduce la URL del sitio:',
  'deploy_sites.add_dialog.ok': 'Añadir sitio',

  'deploy_to_site_dialog.header': 'Publicar en sitio',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>Elige el sitio para publicar la versión {versionTitle} de {projectTitle}.</>,
  'deploy_to_site_dialog.label_site': 'Publicar en sitio:',
  'deploy_to_site_dialog.select_site': 'Seleccionar sitio',
  'deploy_to_site_dialog.select_site.new': 'Añadir nuevo sitio de despliegue...',
  'deploy_to_site_dialog.packages.message.itch': <>Los paquetes se publicarán en itch.io usando <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a>. Los nombres de los canales se derivan de las etiquetas del paquete.</>,
  'deploy_to_site_dialog.deploy': 'Publicar',
  'deploy_to_site_dialog.close': 'Cerrar',
  'deploy_to_site_dialog.error.no_packages': 'No hay paquetes para publicar.',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>No se pueden publicar múltiples paquetes en un solo canal. Actualmente {plural(packagesCount, <>{packagesCountText} paquete está</>, <>{packagesCountText} paquetes están</>)} configurados para publicarse en el canal {channel}.</>,
  'deploy_to_site_dialog.job.queued': 'En cola',
  'deploy_to_site_dialog.job.downloading': 'Descargando...',
  'deploy_to_site_dialog.job.unpacking': 'Desempaquetando...',
  'deploy_to_site_dialog.job.uploading': 'Publicando...',
  'deploy_to_site_dialog.job.succeeded': 'Éxito',
  'deploy_to_site_dialog.job.errored': 'Error',

  'store': 'Tienda',
  'store.hint': 'Proyectos públicos',
  'store.project.hint': 'Página del proyecto en la tienda',
  'store.project.owner': 'Desarrollador',
  'store.project.description': 'Descripción',
  'store.project.star': 'Destacar',
  'store.project.starred': 'Destacado',
  'store.project.content': 'Contenido',
  'store.project.content.warning': 'El contenido ha sido proporcionado por un desarrollador externo.',
  'store.project.branch_version': (branchTitle, versionTitle) => <>Rama {branchTitle}: versión {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>Publicado: {branchVersionPublished}</>,

  'me': 'Perfil',
  'me.hint': 'Ajustes de perfil y credenciales vinculadas',
  'me.rename': 'Renombrar perfil',
  'me.rename_dialog.header': 'Renombrar perfil',
  'me.rename_dialog.label_title': 'Nombre:',
  'me.rename_dialog.ok': 'Renombrar perfil',
  'me.credentials': 'Credenciales',
  'me.credentials.hint.auth_allowed': 'Cualquiera de estas credenciales se puede usar para iniciar sesión en esta cuenta.',
  'me.credentials.hint.auth_disallowed': 'Estas credenciales están vinculadas a tu cuenta, pero no se pueden usar para iniciar sesión.',
  'me.credentials.empty': 'Sin credenciales.',
  'me.credentials.empty.auth_allowed.warning': '¡Podrías perder el acceso a tu cuenta! No has vinculado ninguna credencial para iniciar sesión. Vincula una credencial con la que puedas iniciar sesión lo antes posible.',
  'me.credentials.profile_picture.alt': (provider) => `Foto de perfil de ${dict[`auth.provider.${provider}`]}`,
  'me.credentials.created': (created) => <>añadido {created}</>,
  'me.credentials.last_used': (lastUsed) => <>último uso {lastUsed}</>,
  'me.credential.unlink': 'Desvincular',
  'me.credential.allow_auth': 'Permitir inicio de sesión',
  'me.credential.disallow_auth': 'No permitir inicio de sesión',
  'me.credential.display_publicly': 'Mostrar públicamente',
  'me.credential.dont_display_publicly': 'No mostrar públicamente',
  'me.credential.link': 'Vincular credencial',
  'me.credential.link_dialog.header': 'Vincular credencial',
  'me.credential.link_dialog.message': 'Selecciona el proveedor de cuenta que deseas vincular.',
  'me.credential.unlink_dialog.header': 'Desvincular credencial',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>¿Seguro que quieres desvincular la cuenta de {credentialProvider} {credentialTitle} de tu cuenta de Kavykhi.Cloud?</>,
  'me.credential.unlink_dialog.ok': 'Desvincular credencial',
  'me.sessions': 'Sesiones',
  'me.sessions.hint': 'Esta es una lista de tus sesiones activas, incluyendo tu navegador actual.',
  'me.sessions.started': (started) => <>iniciada <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>activa <span class="value">{lastAuth}</span></>,
  'me.sessions.current': 'Sesión actual',
  'me.sessions.empty': 'Sin sesiones.',
  'me.sessions.delete': 'Terminar',
  'me.sessions.delete_dialog.header': 'Terminar sesión',
  'me.sessions.delete_dialog.message': '¿Seguro que quieres terminar esta sesión?',
  'me.sessions.delete_dialog.ok': 'Terminar sesión',
  'me.api_tokens': 'Tokens de API',
  'me.api_tokens.hint': 'Aquí se pueden crear tokens de API para usar en automatización.',
  'me.api_tokens.started': (started) => <>creado <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>expira <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': 'sin expiración',
  'me.api_tokens.empty': 'Sin tokens de API.',
  'me.api_tokens.create': 'Generar token de API',
  'me.api_tokens.create_dialog.header': 'Generar token de API',
  'me.api_tokens.create_dialog.message': 'Token de API generado:',
  'me.api_tokens.create_dialog.note': 'El token no se volverá a mostrar, guárdalo de forma segura.',
  'me.api_tokens.delete': 'Eliminar',
  'me.api_tokens.delete_dialog.header': 'Eliminar token de API',
  'me.api_tokens.delete_dialog.message': '¿Seguro que quieres eliminar este token?',
  'me.api_tokens.delete_dialog.ok': 'Eliminar token de API',
  'me.deploy_credentials': 'Credenciales de despliegue',
  'me.deploy_credentials.hint': 'Aquí se pueden añadir credenciales para desplegar en plataformas de publicación.',
  'me.deploy_credentials.empty': 'No se han añadido credenciales de despliegue.',
  'me.deploy_credential.add': 'Añadir credencial de despliegue',
  'me.deploy_credential.add_dialog.header': 'Añadir credencial de despliegue',
  'me.deploy_credential.add_dialog.label_site': 'Sitio:',
  'me.deploy_credential.add_dialog.label_title': 'Nota:',
  'me.deploy_credential.add_dialog.label_key': 'Clave:',
  'me.deploy_credential.add_dialog.default_title': (date) => `Clave ${date}`,
  'me.deploy_credential.add_dialog.ok': 'Añadir credencial de despliegue',
  'me.deploy_credential.add_dialog.hint.itch': <>Para generar la clave de API de itch.io, ve a los <a href="https://itch.io/user/settings/api-keys" target="_blank">ajustes de tu perfil</a> en itch.io. Puedes usar una clave de API existente con origen "web" o "wharf". Una clave de API con origen "Kavykhi.Cloud" no funcionará.</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>No soportamos añadir credenciales de {credentialProvider} en este momento.</>,
  'me.deploy_credential.delete': 'Eliminar',
  'me.deploy_credential.delete_dialog.header': 'Eliminar credencial de despliegue',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>¿Seguro que quieres eliminar la credencial {credentialTitle} para {credentialProvider}? Cualquier sitio de despliegue configurado con esta credencial también se eliminará del proyecto.</>,
  'me.deploy_credential.delete_dialog.ok': 'Eliminar credencial',
  'me.public_profile': 'Perfil público',
  'me.public_profile.public_credentials': 'Credenciales públicas',
  'me.public_profile.public_credentials.hint': 'Selecciona las credenciales que deseas mostrar públicamente.',
  'me.manage': 'Gestionar cuenta',
  'me.delete': 'Eliminar cuenta',
  'me.delete.dialog.header': 'Eliminar cuenta',
  'me.delete.dialog.message': (userTitle) => <>¿Seguro que quieres eliminar irrevocablemente tu cuenta de Kavykhi.Cloud {userTitle}?</>,
  'me.delete.dialog.ok': 'Eliminar cuenta',

  'invite': 'Invitación',
  'invite.hint': 'Invitación al proyecto',
  'invite.message.already_member': (projectTitle) => <>Ya eres miembro del proyecto {projectTitle}.</>,
  'invite.message.join': (projectTitle) => <>Has sido invitado al proyecto {projectTitle}.</>,
  'invite.join': 'Unirse al proyecto',

  'local': 'Contenido local',
  'local.hint': 'Contenido instalado localmente',
  'local.workdirs': 'Paquetes instalados',
  'local.workdirs.empty': 'No hay paquetes instalados.',
  'local.workdir.action.launch': 'Iniciar',
  'local.workdir.action.repair': 'Reparar',
  'local.workdir.action.delete': 'Desinstalar',
  'local.workdir.delete_dialog.header': 'Desinstalar paquete',
  'local.workdir.delete_dialog.message': (packageTitle) => <>¿Seguro que quieres desinstalar el paquete {packageTitle} de tu dispositivo?</>,
  'local.workdir.delete_dialog.ok': 'Desinstalar',
  'local.workspaces': 'Carpetas raíz',
  'local.app_not_detected.message': 'No se detecta la aplicación local de Kavykhi.Cloud. Descárgala e instálala usando uno de los enlaces de abajo. Si ya la instalaste, asegúrate de que se está ejecutando.',

  'local_app.detected': 'Contenido local',

  'error_dialog.header': 'Error',
  'error_dialog.messageFunc': (e) => `Error: ${dict[`error.${e}`] ?? e}.`,

  'upload_box.choose_files': 'Elegir archivos',
  'upload_box.choose_directories': 'Elegir carpetas',
  'upload_box.add.progress_dialog.header': 'Añadiendo archivos',
  'upload_box.add.progress_dialog.message': 'Procesando archivos...',
  'upload_box.delete': (itemsCount) => `Eliminar ${plural(itemsCount, `${itemsCount} elemento`, `${itemsCount} elementos`)}`,
  'upload_box.start_upload': 'Iniciar subida',
  'upload_box.drop_area.message': 'Arrastra archivos y carpetas aquí',
  'upload_box.drop_area.box_dropping_message': 'Suelta aquí para colocar en la raíz',
  'upload_box.entry.explode_folder': 'Reemplazar carpeta con su contenido',
  'upload_box.entry.set_entrypoint': 'Establecer archivo de inicio',
  'upload_box.entry.mark_executable': 'Marcar como ejecutable',
  'upload_box.entry.unmark_executable': 'Desmarcar como ejecutable',
  'upload_box.entry.remove': 'Quitar',

  'package.tags.empty': '(sin etiquetas)',
  'package.tag.os': 'SO',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': 'Arq',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': 'Bits',
  'package.tag.bits:64': '64 bits',
  'package.tag.bits:32': '32 bits',
  'package.tag.packaging': 'Empaquetado',
  'package.tag.packaging:installer': 'Instalador',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': 'Componente',
  'package.tag.component:client': 'Cliente',
  'package.tag.component:server': 'Servidor',
  'package.tag.runtime': 'Entorno de ejecución',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Distribución Linux',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': 'Docs',
  'docs.page_no_language': 'No disponible en este idioma',
  'docs.page_no_language.message': 'Otras versiones disponibles de este documento:',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': 'Reportar contenido',
  'report_content.dialog.header': 'Reportar contenido',
  'report_content.dialog.link': 'Enviar reporte por email',
  'report_content.dialog.message': (email, link) => <>Haz clic en el enlace para enviar tu reporte:<br /><br />{link}<br /><br />O envíanos un correo manualmente a {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
